// Should stay in sync with reportFormatTypes.mjs

export const REPORT_FORMAT_TYPES = {
  CSV: 1,
  PDF: 2,
  COMBINED_FORMATS: 3
};
